export default "__VITE_ASSET__e6CJoj_t__"